import { AxiosRequestConfig, AxiosResponse, AxiosInstance, AxiosError } from 'axios';

const axios = require('axios');

class ApiService {
    readonly baseAxios: AxiosInstance;
    readonly authHeader: string;

    constructor(baseUrl: string, userToken: string, authHeaderName: string) {
        this.baseAxios = axios.create({
            baseUrl: baseUrl
        });
        this.authHeader = userToken;
        this.baseAxios.defaults.headers[authHeaderName] = userToken;
        this.baseAxios.defaults.headers['Pragma'] = 'no-cache';
    }

    async get<T = any>(url: string, callback: (response: T) => any, errorCallback?: (error: any) => any, config?: AxiosRequestConfig) {
        this.baseAxios
            .get(url, config)
            .then((response: AxiosResponse<T>) => callback(response.data))
            .catch((error: AxiosError) => this.errorHandler(error, errorCallback));
    }

    // Get implementaton with no callbacks
    async Get<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
        return this.baseAxios
            .get(url, config)
            .catch((error: AxiosError) => {
                this.errorHandler(error);
                throw error;
            })
            .then((response: AxiosResponse<T>) => response.data);
    }

    async post<T = any>(url: string, body: any, callback: (response: T) => any, errorCallback?: (error: any) => any, config?: AxiosRequestConfig) {
        this.baseAxios
            .post(url, body, config)
            .then((response: AxiosResponse<T>) => callback(response.data))
            .catch((error: AxiosError) => this.errorHandler(error, errorCallback));
    }

    // Post implementaton with no callbacks
    async Post<T = any>(url: string, body: any, config?: AxiosRequestConfig): Promise<T> {
        return this.baseAxios
            .post(url, body, config)
            .catch((error: AxiosError) => {
                this.errorHandler(error);
                throw error;
            })
            .then((response: AxiosResponse<T>) => response.data);
    }

    errorHandler = (err: AxiosError, errorCallback?: (error: AxiosError) => any) => {
        if (!!errorCallback) {
            errorCallback(err);
        }
    };
}

declare global {
    interface Window {
        initialstate: any;
    }
}

const getBaseUrl = (): string => {
    let baseUrl = undefined;

    try {
        baseUrl = window.sessionStorage.getItem('verifyBaseUrl')?.toString();
    } catch (e) {
        // Handle old browser without session storage
    } finally {
        if (!baseUrl) {
            baseUrl = window.verifyBaseUrl;
        }
    }

    if (!baseUrl) {
        console.error('Cannot find the base url');
    }

    return baseUrl !== undefined ? baseUrl : '';
};

const getAuthHeaderName = (): string => {
    let authHeaderName = undefined;

    try {
        authHeaderName = window.sessionStorage.getItem('authHeaderName')?.toString();
    } catch (e) {
        // Handle old browser without session storage
    } finally {
        if (!authHeaderName) {
            authHeaderName = window.authHeaderName;
        }
    }

    if (!authHeaderName) {
        console.error('Cannot find the auth header name');
    }
    return authHeaderName !== undefined ? authHeaderName : '';
};

const getToken = (): string => {
    let token = undefined;

    try {
        token = window.sessionStorage.getItem('X-vfyst')?.toString();
    } catch (e) {
        // Handle old browser without session storage
    } finally {
        if (!token) {
            token = window.securityToken;
        }
    }


    if (!token) {
        console.error('Cannot find the token');
    }

    return token !== undefined ? token : '';
};

const AUTH_HEADER_NAME: string = getAuthHeaderName();
const BASE_URL: string = getBaseUrl();
const USER_TOKEN: string = getToken();
export let apiService = new ApiService(BASE_URL, USER_TOKEN, AUTH_HEADER_NAME);
